<i18n src="@/locales/modules/TitleTranslate.json"></i18n>

<template>
	<div class="title-config">
		<div>
			<!-- NAME -->
			<label class="vs-input--label">
				{{ $t("TitleName") }}
				<span class="text-danger">*</span>:
			</label>
			<vs-input
				:data-vv-as="$t('TitleName')"
				:placeholder="`${$t('Actions.Input')} ${$t('TitleName')}`"
				v-model="localTitle.name"
				class="w-full"
				:name="`${formName}-name`"
				v-validate="'required'"
			/>
			<span class="text-danger text-sm" v-show="errors.has(`${formName}-name`)">{{ errors.first(`${formName}-name`) }}</span>
		</div>
		<div class="my-4 ">
			<label for class="vs-input--label">{{ $t("Roles") }}<span class="text-danger">*</span>:</label>
			<CbsEmployeeRoles
				class="w-full"
				:name="`${formName}-employee-roles`"
				v-validate="'required'"
				v-model="localTitle.role"
				:close-on-select="false"
				:placeholder="`Chọn vai trò hoặc nhập tên vai trò và nhấn Enter để tạo mới`"
				:data-vv-as="$t('Roles')"
			/>
			<span class="text-danger text-sm" v-show="errors.has(`${formName}-employee-roles`)">{{ errors.first(`${formName}-employee-roles`) }}</span>
		</div>
		<div>
			<vs-checkbox :disabled="disabledLeader" v-model="localTitle.is_lead">{{ $t("IsLeader") }}</vs-checkbox>
		</div>

		<div class="flex items-center justify-end">
			<vs-button radius type="flat" class="p-0" color="primary" icon-pack="nucleo" icon="nucleo-trash-can" @click="$emit('onClickDelete', localTitle)"></vs-button>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";
import vSelect from "vue-select";

import CbsEditor from "@/components/cbs-editor/CbsEditor";
import CbsEmployeeRoles from "@/components/cbs-employee-roles/CbsEmployeeRoles";
const isValidTitleData = title => _.has(title, "id") && _.has(title, "name") && _.has(title, "role");

export default {
	name: "TitleConfig",
	inject: ["parentValidator"],
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => isValidTitleData(prop)
		},
		formName: {
			type: String,
			default: "title-config"
		},
		disabledLeader: {
			type: Boolean,
			default: false
		}
	},
	emits: {
		onClickDelete: {}
	},
	components: {
		vSelect,
		CbsEditor,
		CbsEmployeeRoles
	},
	data() {
		return {};
	},
	computed: {
		localTitle: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss">
.title-config {
	padding: 25px;
	border-radius: 4px;
	background: #f8f8f8;
}
</style>
